export default {
  occurrenceUnit: 'wystąpienie | wystąpienia',
};
